const config = {
    basename: '',
    defaultPath: '/',
    fontFamily: 'Nunito, sans-serif',
    borderRadius: 6,
    // Google Analytics Measurement ID (formato: G-XXXXXXXXXX)
    // Substitua pelo seu ID real do Google Analytics 4
    googleAnalyticsMeasurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || ''
};

export default config;
